import { Survey } from '../entities/Survey';

export function findCandidateSurvey(surveys: Survey[]): Survey | undefined {
  return surveys.find((survey) => survey.relationship === 'candidate');
}
